// import React from "react";
// import { Box, Tabs, Tab } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useTabVisibility } from "./TabVisibility";

// const MobileHeaderTabs = () => {
//   const { isVisible } = useTabVisibility();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleChange = (event, newValue) => {
//     navigate(newValue);
//   };

//   const tabItems = [
//     { label: "My Store", value: "/myStore" },
//     { label: "Subscriptions & Services", value: "/subscription" },
//     { label: "Payment Methods", value: "/payments" },
//     { label: "Activity", value: "/activity" },
//     { label: "Addresses", value: "/address" },
//   ];

//   return (
//     <Box sx={{ display: "flex", alignItems: "center", maxWidth: "100%" }}>
//       {isVisible && (
//         <Box
//           sx={{
//             borderColor: "divider",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             width: "100%",
//             overflowX: "hidden",
//           }}
//         >
//           <Tabs
//             value={location.pathname}
//             onChange={handleChange}
//             aria-label="Header Navigation Tabs"
//             scrollButtons={false}
//             variant="standard"
//             TabIndicatorProps={{
//               sx: {
//                 display: "none"
//               },
//             }}
//             sx={{
//               width: "100%",
//               minHeight: "40px",
//             }}
//           >
//             {tabItems.map((tab) => (
//               <Tab
//                 key={tab.value}
//                 sx={{
//                   minWidth: 0,
//                   flex: 1,
//                   padding: "2px",
//                   fontSize: "0.7rem",
//                   textTransform: "none",
//                 }}
//                 label={
//                   <label style={{ position: 'relative', display: 'inline-block' }}>
//                   {tab.label}
//                   {location.pathname === tab.value && (
//                     <span
//                       style={{
//                         position: 'absolute',
//                         left: 0,
//                         bottom: -4,
//                         height: 2,
//                         width: '100%',
//                         backgroundColor: '#1976d2',
//                         borderRadius: 1,
//                       }}
//                     />
//                   )}
//                 </label>
//                 }
//                 value={tab.value}
//               />
//             ))}
//           </Tabs>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default MobileHeaderTabs;
import { TfiLayoutColumn3 } from "react-icons/tfi";
import { GoCreditCard } from "react-icons/go";
import { BsCollectionPlay } from "react-icons/bs";
import { useTheme } from "../../style/theme";
import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Image from "../../components/Image";

const MobileTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mode } = useTheme();

  const handleChange = (event, newValue) => {
    navigate(newValue);
  };

  const tabItems = [
    {
      label: "My Store",
      value: "/myStore",
      icon: <BsCollectionPlay size={24} />,
    },
    {
      label: "Subscriptions & Services",
      value: "/subscription",
      icon: <BsCollectionPlay size={24} />,
    },
    {
      label: "Payment Method",
      value: "/payments",
      icon: <GoCreditCard size={24} />,
    },
    {
      label: "Activity",
      value: "/activity",
      icon: <TfiLayoutColumn3 size={24} />,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%", // Width of the drawer
        minHeight: "100vh", // Full height of screen
        backgroundColor: mode === "light" ? "#fff" : "#141414",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Logo Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pb: 3,
          pt: 2,
          gap: 1,
        }}
      >
        <Image
          cdn="store/logo/Clikkle Store Icon.png"
          sx={{ height: "50px" }}
        />
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 500,
              color: "#A5A5A5",
              paddingRight: "5px",
            }}
          >
            Clikkle
          </span>
          <span
            style={{
              fontSize: "20px",
              fontWeight: "normal",
              color: "GrayText",
            }}
          >
            Store
          </span>
        </span>
      </Box>

      {/* Tabs Section */}
      <Tabs
        orientation="vertical"
        value={location.pathname === "/" ? "/myStore" : location.pathname}
        onChange={handleChange}
        sx={{
          flexGrow: 1,
          "& .MuiTabs-flexContainer": {
            flexDirection: "column",
            paddingLeft: "6px",
          },
        }}
        TabIndicatorProps={{
          sx: {
            display: "none",
          },
        }}
      >
        {tabItems.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            icon={tab.icon}
            iconPosition="start"
            sx={{
              fontSize: "18px",
              justifyContent: "flex-start",
              textAlign: "left",
              textTransform: "none",
              alignItems: "flex-start",
              mb: 1,
              fontWeight: location.pathname === tab.value ? 600 : 400,
              color: location.pathname === tab.value ? "#1976d2" : "inherit",
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default MobileTabs;
